import Centro from "./Centro";

export default class MedicoCentro extends Centro {
    IdMedicoCentro:number=null;
    IdSolicitudMedico:number=null;
    IdCentroMedico:number=null;
    NombreCentro:string=""
}